import React, { useEffect,useState,useRef } from "react";
import { Hooks,Util,Request } from "@xt/xtbase";
const {useTranslation} = Hooks;
const {moment,Big,getUrl,showRate} = Util;
moment.locale("en");
const {XtSocketPublic} = Request;
import styles from "./index.module.less";
import {get_kline,get_ticker24h,get_topConfig} from "@/api/v4/market";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import XtPane from "@/components/App/XtPane";
import LineChart from "@/components/App/LineChart";

const cacheData = {};
const marketsChartMap = {};
const kInterval = "1h";
const kLimit = 24;
const klineEvents = [];
const ListingHistory = () => {
  const t = useTranslation();
  const { fund, market } = useStore();
  const [chooseTab, setChooseTab] = useState("newest");
  const [chooseSubTab, setChooseSubTab] = useState("Spot");
  const [loading, setLoading] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [chartList, setChartList] = useState([]);
  const chooseTabRef = useRef(chooseTab);
  const chooseSubTabRef = useRef(chooseSubTab);
  useEffect(()=>{
    initMakertGroup();
    XtSocketPublic.addChannel({event:"tickers"}, handleWsCallback);
    return ()=>{
      XtSocketPublic.removeChannel({ event: "tickers" });
      if (klineEvents && klineEvents.length > 0) {
        klineEvents.forEach((s) => {
          XtSocketPublic.removeChannel({ event: "kline@" + s + "," + kInterval });
        });
      }
    }
  },[]);
  useEffect(()=>{
    initChartData();
  },[groupList]);
  const handleWsCallback = (res) => {
    if (!Array.isArray(res) || res.length <= 0) return;
    res.forEach((r) => {
      let i = cacheData.allMarketData.findIndex((d) => {
        return d.s == r.s;
      });
      cacheData.allMarketData[i] = r;
    });
    handleGroupList(chooseTabRef.current, chooseSubTabRef.current);
  }
  const handleWsKlineCallback = (res)=>{
    if (!marketsChartMap[res.s]) marketsChartMap[res.s] = [];
    var list = [];
    var flag = true;
    marketsChartMap[res.s].forEach((item) => {
      if (item.t == res.t) {
        list.push(res);
        flag = false;
      } else list.push(item);
    });
    if (flag) list.unshift(res);
    marketsChartMap[res.s] = list;
    //setChartList((groupList.map((g) => {
    //  return marketsChartMap[g.s] || [];
    //})));
  }
  const changeGroupList = (newList) => {
    let addList = [];
    let removeList = [];
    if (Array.isArray(newList) && newList.length > 0) {
      newList.forEach((item) => {
        addList.push(item.s);
      });
    }
    if (Array.isArray(klineEvents) && klineEvents.length > 0) {
      klineEvents.forEach((item) => {
        let i = addList.indexOf(item);
        if (i >= 0) addList.splice(i, 1);
        else removeList.push(item);
      });
    }
    if (removeList.length > 0) {
      removeList.forEach((s) => {
        XtSocketPublic.removeChannel({ event: "kline@" + s + "," + kInterval });
      });
    }
    if (addList.length > 0) {
      addList.forEach((s) => {
        XtSocketPublic.addChannel({ event: "kline@" + s + "," + kInterval }, handleWsKlineCallback);
      });
      klineEvents = addList;
    }
    setGroupList(newList);
    setChartList((newList.map((g) => {
      return marketsChartMap[g.s] || [];
    })));
  }
  const initMakertGroup = async ()=>{
    try {
      setLoading(true);
      cacheData.allMarketData = await get_ticker24h();
      cacheData.topConfig = await get_topConfig();
      handleGroupList(chooseTab);
    } catch (error) {
      console.log("initMarket-----", error);
    } finally {
      setLoading(false);
    }
  }
  const handleGroupList = (tab, subTab)=>{
    if(!tab)tab = chooseTab;
    if(!subTab)subTab = chooseSubTab;
    const { allMarketData, topConfig } = cacheData;
    if (!allMarketData || !topConfig) return;
    const config = topConfig[tab];
    if (!config) return;
    const {marketConfig} = market;
    let topList = [];
    if (config.topSymbols) {
      for (let i = 0; i < config.topSymbols.length; ++i) {
        let symbol = config.topSymbols[i];
        let index = allMarketData.findIndex((d) => {
          return d.s == symbol;
        });
        if (index >= 0) {
          topList.push(allMarketData[index]);
          if (topList.length >= 10) break;
        }
      }
    }
    if (topList.length >= 10) {
      changeGroupList(topList.slice(0, 10));
      return;
    }
    let filterlist = allMarketData.filter((d) => {
      if (!d.s) return false;
      const mConfig = marketConfig[d.s];
      if (!mConfig || mConfig.state == "DELISTED" || mConfig.displayLevel == "NONE") return false;
      if (
        topList.length > 0 &&
        topList.findIndex((t) => {
          return t.s == d.s;
        }) >= 0
      )
        return false;
      let coins = d.s.split("_");
      if (coins.length < 2) return false;
      if (config.excludeSymbols && config.excludeSymbols.includes(d.s)) return false;
      if (config.excludeBaseCurrencies && config.excludeBaseCurrencies.includes(coins[0])) return false;
      if (config.excludeQuoteCurrencies && config.excludeQuoteCurrencies.includes(coins[1])) return false;
      if (config.excludeVolumeLt) {
        if (coins[1].toLowerCase() == "usdt") {
          if (config.excludeVolumeLt > parseFloat(d.v)) return false;
        } else {
          const c_u = allMarketData.find((d) => {
            return d.s.toLowerCase() == coins[1].toLowerCase() + "_usdt";
          });
          if (!c_u || config.excludeVolumeLt > c_u.c * d.v) return false;
        }
      }
      if (tab == "up" || tab == "down") {
        if (subTab == "Spot" && market.isEtfMarket(d.s)) return false;
        if (subTab == "Etf" && !market.isEtfMarket(d.s)) return false;
      }
      return true;
    });
    if (tab === "up")
      filterlist.sort((x, y) => {
        return (y.cr || y.r) - (x.cr || x.r);
      });
    else if (tab === "down")
      filterlist.sort((x, y) => {
        return (x.cr || x.r) - (y.cr || y.r);
      });
    else if (tab === "hot"){
      filterlist.sort((x, y) => {
        let xv = x.v;
        let yv = y.v;
        const xcoins = x.s.split("_");
        if (xv > 0 && xcoins.length > 1 && xcoins[1].toLowerCase() != "usdt") {
          const xs_u = allMarketData.find((d) => {
            return d.s.toLowerCase() == xcoins[1].toLowerCase() + "_usdt";
          });
          if (xs_u) xv *= xs_u.c;
        }
        const ycoins = y.s.split("_");
        if (yv > 0 && ycoins.length > 1 && ycoins[1].toLowerCase() != "usdt") {
          const ys_u = allMarketData.find((d) => {
            return d.s.toLowerCase() == ycoins[1].toLowerCase() + "_usdt";
          });
          if (ys_u) yv *= ys_u.c;
        }
        return yv - xv;
      });
    }
    else if (tab === "newest")
      filterlist.sort((x, y) => {
        return getMaketOpenTimeTs(y.s) - getMaketOpenTimeTs(x.s);
      });
    changeGroupList(topList.concat(filterlist.slice(0, 10 - topList.length)));
  }
  const initChartData = ()=>{
    if (!groupList?.length) return;
    groupList.forEach((item) => {
      if (marketsChartMap[item.s] && marketsChartMap[item.s].length > 0) return;
      get_kline({
        params: {
          symbol: item.s,
          interval: kInterval,
          limit: kLimit,
        },
      }).then((data) => {
        marketsChartMap[item.s] = data;
        setChartList((groupList.map((g) => {
          return marketsChartMap[g.s] || [];
        })));
      });
    });
  }
  const handleChangeTab = (tab)=>{
    setChooseTab(tab);
    chooseTabRef.current = tab;
    setChooseSubTab("Spot");
    chooseSubTabRef.current = "Spot";
    handleGroupList(tab,"Spot");
  }
  const onMarketGroupClick = (item)=>{
    if(chooseTab == "futures")
      location.href = getUrl(`/futures/trade/${item.s}`);
    else
      location.href = getUrl(`/trade/${item.s}`);
  }
  const getCoinIcon = (symbol) => {
    if (!symbol) return require("@/assets/images/common/icon404.png").default;
    const { currencyMap } = fund;
    const coin = symbol.split("_")[0];
    const rawLogo = currencyMap?.[coin]?.["logo"];
    if (!rawLogo) return require("@/assets/images/common/icon404.png").default;
    const domain = document.domain;//先获取当前访问的全域名
    const domain2 = domain.substring(domain.indexOf('.')+1);//截取第一个点的位置来获取根域名
    return !domain.startsWith('xt') ? rawLogo.replace('xt.com', domain2) : rawLogo;
  }
  const getCoinName = (symbol) => {
    if (!symbol) return;
    return symbol.split("_")[0];
  }
  const getMarketName = (symbol) => {
    if (!symbol) return;
    return symbol.split("_").length > 1 ? symbol.split("_")[1] : "";
  }
  const formatPrice = (item) => {
    const { s: marketName, c: latestPrice } = item;
    if (latestPrice == null || isNaN(+latestPrice)) return 0;
    const mConfig = market.marketConfig[marketName];
    return Big(latestPrice).toFixedCy(mConfig && mConfig.buyPoint ? mConfig.buyPoint : 2);
  }
  const fontClass = (rate) => {
    return !isNaN(+rate) && +rate != 0 ? (+rate > 0 ? styles["up-color"] : styles["down-color"]) : styles["up-color"];
  }
  const fontClassGlobal = (rate) => {
    return !isNaN(+rate) && +rate != 0 ? (+rate > 0 ? "up-color" : "down-color") : "down-color";
  }
  const formatRate = (rate) => {
    return showRate(rate * 100);
  }
  const getMaketOpenTime = (symbol) => {
    return market.marketConfig[symbol] ? moment(market.marketConfig[symbol].stateTime).format("YYYY-MM-DD") : "";
  }
  const getMaketOpenTimeTs = (symbol) => {
    return +market.marketConfig[symbol].stateTime;
  }
  const onMarketChange = (key) => {
    setChooseSubTab(key);
    chooseSubTabRef.current = key;
    handleGroupList(chooseTab, key);
  }
  return <div className={`market-group-container ${styles["market-group-container"]}`}>
    <div className={`market-group-container-view ${styles["market-list-view"]}`}>
      <ul className={styles["list-header"]}>
        <li>{ t("home.Name") }</li>
        <li>{ t("home.LastPrice") }</li>
        <li>{ t("home.24hChange") }</li>
        {chooseTab === 'newest' ? <li>{ t("home.launchTime") }</li> : null}
        <li>{ t("home.Markets") }</li>
        <li>{ t("home.operation") }</li>
      </ul>
      <XtPane className={styles["list-content"]} loading={loading} nodata={false}>
        {groupList.map((item,index)=>{
          return <ul key={item.s} className={styles["list-content-ul"]} onClick={()=>onMarketGroupClick(item)}>
            <li>
              <img src={getCoinIcon(item.s)} alt="" />
              <span className={styles["text-uppercase"]} style={{"fontSize":"16px"}}>{ chooseTab == "futures" ? item.s.replace("_","").toUpperCase() : getCoinName(item.s) }</span>
              {chooseTab == "futures" ? null : <span style={{marginTop: '2px'}}>/</span>}
              {chooseTab == "futures" ? null : <span style={{marginTop: '2px'}} className={styles["text-uppercase"]}>{ getMarketName(item.s) }</span>}
            </li>
            <li className={styles["last-price-li"]}>
              <div className={styles["last-price-li-div"]}>
                <div className={styles["last-price"]}>
                  <span>{ formatPrice(item) } </span>
                </div>
                {/* <div className={styles["rate-mb"]}>
                  <span className={fontClass(item.cr)}>{ formatRate(item.cr) }</span>
                </div> */}
              </div>
            </li>
            <li>
              <span className={fontClass(item.cr || item.r)}>{ formatRate(item.cr || item.r) }</span>
            </li>
            {chooseTab === 'newest' ? <li>
              { getMaketOpenTime(item.s) }
            </li> : null}
            <li>
              <LineChart itemKey={"home_market_chart_"+item.s} chartData={chartList[index]} theme={fontClassGlobal(item.cr || item.r)} width={120} height={40}/>
            </li>
            <li>
              <div className={styles["list-content-li-trade"]}>{ t("home.TRADE") }</div>
            </li>
          </ul>
        })}
      </XtPane>
    </div>
  </div>;
}
export default observer(ListingHistory);